import Axios from 'axios'
import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import { DELETE_AGENT_FROM_MAIN_LIST, GET_AGENTS_LIST } from '../../config/rest_endpoints'
import Container from '../common/application_container'
import { RC_LOAD_LOGIN } from '../routers/RouteConstants'
import { Notifications } from '../common/notification';
import CustomLoader from '../common/loader'
import CustomModal from '../common/modal'
import CreateAgent from './createAgent'
import UpdateAgent from './updateAgent'
import Pagination from "react-js-pagination";


export default class AgentMainTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            agentsTable:[],
            isGetting:false,
            addAgent:false,
            agentEdit:false,
            agentDelete:false,
            agentDeleteInfo:{},
            agentId:'',
            updateAgentInfo:{},
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
            isLoginURL: false
        }
        this.openAgentModal = this.openAgentModal.bind(this)
        this.closeAgentModal = this.closeAgentModal.bind(this)
        this.getAgentData = this.getAgentData.bind(this)
        this.openEditModal = this.openEditModal.bind(this)
        this.closeEditModal = this.closeEditModal.bind(this)
        this.openDeleteAgent = this.openDeleteAgent.bind(this)
        this.closeDeleteAgent = this.closeDeleteAgent.bind(this)
        this.deleteAgentCall = this.deleteAgentCall.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }
    
    componentDidMount() {
        this.getAgentData()
    }

    openAgentModal() {
        this.setState({addAgent:true})
    }

    closeAgentModal() {
        this.setState({addAgent:false})
    }

    openEditModal(data) {
        this.setState({
            agentEdit:true,
            updateAgentInfo:data
        })
    }

    closeEditModal() {
        this.setState({agentEdit:false})
    }

    openDeleteAgent(data,id) {
        let agentInfo = data
        delete agentInfo['id']
        this.setState({
            agentDelete:true,
            agentDeleteInfo:agentInfo,
            agentId:id
        })
       
    }

    closeDeleteAgent() {
        this.setState({agentDelete:false})
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.getAgentData()
        });
    }

    getAgentData() {
        const {User,activePage,itemsCount} = this.state
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${GET_AGENTS_LIST}?page=${activePage}&limit=${itemsCount}`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                this.setState({
                    agentsTable: res.data.data,
                    isGetting: false,
                    totalCount:res.data.pageinfo.totalCount
                })
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            var logs = err.response.status
            console.log('logs :>> ', logs);
            if (logs === 401) {
                localStorage.removeItem('user');
                this.props.history.push(RC_LOAD_LOGIN);
            }
            Notifications.notify("Failed to fetch", "Failed", "errors")

        })

    }

    renderAgentTable() {
        const {agentsTable} = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!agentsTable.length) {
            return nullData
        }
        else {
            return agentsTable.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.name}</td>
                        <td style={{textAlign:'center'}}>{row.email}</td>
                        <td style={{textAlign:'center'}}>{row.phone}</td>
                        <td style={{textAlign:'center'}}>{row.commission}</td>
                        <td style={{textAlign:'center'}}>{row.type}</td>
                        <td style={{textAlign:'center'}}>{row.frequency === '' ? "N/A" :row.frequency }</td>
                        <td style={{textAlign:'center'}}>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                        <td style={{textAlign:'center',fontSize:'20px'}} className='edit-button'><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this,row)} ></i><i className="fa fa-trash text-danger" aria-hidden="true" onClick={this.openDeleteAgent.bind(this,row,row.id)}></i></td>
                    </tr>
                )
            })
        }
    }

    deleteAgentCall() {
        const {User,agentId,agentDeleteInfo} = this.state
        var payload = agentDeleteInfo
        console.log(payload)
        // this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        this.setState({isLoad:true})
        Axios.delete(`${DELETE_AGENT_FROM_MAIN_LIST}/${agentId}/delete`, { headers }).then(res => {
            if (res) {
                Notifications.notify(`${agentDeleteInfo.name} deleted Successfully`, "Success", "success")
                this.closeDeleteAgent()
                this.getAgentData()
                this.setState({isLoad:false})
            }
            else {
                Notifications.notify("Fetch failed", "error", "error")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isLoad: false
            })
        })
    }


    render() {
       const {agentDeleteInfo,updateAgentInfo,totalCount,activePage,itemsCount} = this.state
       console.log('totalCount :>> ', totalCount);
        let addAgent = {
            details: {
                info: "Create Agent",
                msg:<CreateAgent close={this.closeAgentModal} listing={this.getAgentData} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeAgentModal },
            cancelBtn: { label: "Cancel", action: this.closeAgentModal }
        }

        let editAgent = {
            details: {
                info: "Update Agent",
                msg:<UpdateAgent previousInfo={updateAgentInfo} close={this.closeEditModal} listing={this.getAgentData} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeEditModal },
            cancelBtn: { label: "Cancel", action: this.closeEditModal }
        }

        let deleteAgent = {
            details: {
                info: "Delete Agent",
                msg:(
                    <div>
                        <div class="modal-body">
                            <h4>Are you sure want to delete <b>{agentDeleteInfo['name']}</b> ? </h4>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-light" onClick={this.closeDeleteAgent} data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-danger" onClick={this.deleteAgentCall} disabled={this.state.isLoad ? true :false}  > Confirm  <i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : "icon-database-remove ml-1 icon-1x"}></i></button>
                        </div>
                    </div>
                )
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeDeleteAgent },
            cancelBtn: { label: "Cancel", action: this.closeDeleteAgent }
        }

        return (
           <Container title="Agent" title1="Table" icon="fa fa-user">
                 <CustomModal
                    visibility={this.state.addAgent}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addAgent.details}
                    modalSize={"modal-lg"}
                    showBtns={false}
                    cancelBtn={addAgent.cancelBtn}
                    crossBtn={addAgent.crossBtn}
                />

                <CustomModal
                    visibility={this.state.agentEdit}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={editAgent.details}
                    modalSize={"modal-lg"}
                    showBtns={false}
                    cancelBtn={editAgent.cancelBtn}
                    crossBtn={editAgent.crossBtn}
                />

                <CustomModal
                    visibility={this.state.agentDelete}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={deleteAgent.details}
                    modalSize={"modal-lg"}
                    showBtns={false}
                    cancelBtn={deleteAgent.cancelBtn}
                    crossBtn={deleteAgent.crossBtn}
                />

<div className='row  mb-3 '>
                        <div className='col-md-3 offset-md-9 '>
                        <button type="submit" className="main-button btn btn-success btn-sm ml-3 float-right" onClick={this.openAgentModal} >Agent Create <i className="fas fa-plus ml-2"></i></button>

                        </div>
                </div>

                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div className="card-header header-elements-inline p-0 py-1 mb-1">
                        <h4 style={{fontWeight:'700',fontSize:'24px'}} className="card-title">
                            
                        </h4>
                        <div className="header-elements">
                        </div>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header border-0">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..."  aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div 
                            className="datatable-scroll" 
                            style={{overflowX: 'auto' }}>
                            <table 
                            className="table-style table table-striped dataTable no-footer" 
                            id="DataTables_Table_0" 
                            role="grid" 
                            aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader table-heading-style">
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Commission</th>
                                        <th>Type</th>
                                        <th>Frequency</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {this.state.isGetting ? <CustomLoader /> : this.renderAgentTable()}
                                </tbody>
                            </table>
                        </div>
                       <div className="datatable-footer mt-1">
                            {totalCount >= 9 ?
                             <Pagination
                             activePage={activePage}
                             itemsCountPerPage={itemsCount}
                             totalItemsCount={totalCount}
                             pageRangeDisplayed={5}
                             onChange={this.handlePageChange.bind(this)}
                         /> : ''
                        }
                           
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>  
            </Container>
        )
    }
}
